import { ReactNode } from "react";
import { Blocker } from "react-router-dom";
import { cn } from "../lib/utils";
import { ClickableIcon } from "../primitives";
import { Button, ButtonColor } from "../ui/Button";
import { Modal } from "./Modal";

export type NavigationBlockerModalProps = {
	blocker: Extract<Blocker, { state: "blocked" }>;
	onConfirm?: () => void;
	onCancel?: () => void;
	message?: ReactNode;
	subMessage?: ReactNode;
	confirmButtonText?: string;
	confirmationButtonColor?: ButtonColor;
	cancelButtonText?: string;
	cancelButtonColor?: ButtonColor;
	isSubmitting?: boolean;
	className?: string;
	trackingPrefix?: string;
};

export const NavigationBlockerModal = ({
	blocker,
	onConfirm,
	onCancel,
	message,
	subMessage,
	confirmButtonText,
	confirmationButtonColor = "primary",
	cancelButtonText,
	cancelButtonColor = "secondary",
	isSubmitting = false,
	className,
	trackingPrefix,
}: NavigationBlockerModalProps) => (
	<Modal onClickOutside={isSubmitting ? undefined : () => blocker.reset()}>
		<div
			className={cn(
				"relative py-[35px] px-[35px] bg-surface-base flex flex-col items-center rounded-md shadow-lg space-y-[35px]",
				className,
			)}
		>
			{!isSubmitting && (
				<ClickableIcon
					type="x-mark"
					size="small"
					color="secondary"
					className="absolute top-4 right-4"
					onClick={() => blocker.reset()}
					trackingId={trackingPrefix ? `${trackingPrefix}-abandon-close` : undefined}
				/>
			)}
			<div className="flex flex-col items-center space-y-[15px]">
				{message !== undefined && (
					<div className="text-[18px] text-primary font-normal w-full flex text-center">
						{message}
					</div>
				)}
				{subMessage !== undefined && (
					<div className="text-[16px] text-secondary text-center">{subMessage}</div>
				)}
			</div>
			<div className="w-fit flex space-x-[8px] items-center">
				<Button
					color={cancelButtonColor}
					className="w-[125px]"
					thinFont
					disabled={isSubmitting}
					onClick={onCancel}
					trackingId={trackingPrefix ? `${trackingPrefix}-abandon-discard` : undefined}
				>
					{cancelButtonText ?? "Cancel"}
				</Button>
				<Button
					color={confirmationButtonColor}
					className="w-[125px]"
					filled
					loading={isSubmitting}
					onClick={() => onConfirm?.()}
					trackingId={trackingPrefix ? `${trackingPrefix}-abandon-save` : undefined}
				>
					{confirmButtonText ?? "Confirm"}
				</Button>
			</div>
		</div>
	</Modal>
);
